import { BathProductPage, BathProductConfig } from "@/components/bath/BathProductPage";

const config: BathProductConfig = {
  slug: "aria-monolith",
  category: "Architectural Oval Bathtub",
  productName: "ARIA Monolith Architectural Oval Solid Surface Bathtub",
  shortName: "ARIA Monolith",
  sku: "ARIA-MONOLITH-1750",
  schemaCategory: "Bathtubs > Freestanding > Solid Surface",
  metaTitle: "ARIA Monolith Architectural Oval Bathtub | Solid Surface",
  metaDescription:
    "ARIA Monolith — architectural oval freestanding solid surface bathtub for villas, branded residences and signature suites. CE certified, MOQ-ready.",
  heroEyebrow: "Project Solutions · Architectural Bathtub",
  heroHeadline: (
    <>
      Architectural Oval{" "}
      <span className="bg-gradient-to-r from-amber-300 via-amber-400 to-amber-200 bg-clip-text text-transparent">
        Solid Surface Bathtub
      </span>{" "}
      — Monolithic Form
    </>
  ),
  heroIntro:
    "A pure oval silhouette cast as a single seamless monolith. ARIA Monolith reads as architecture, not plumbing — designed for villas, primary suites and signature spaces where the tub is the room.",
  premiumSummary:
    "A freestanding solid surface bathtub with an architecturally pure oval form. Stone-resin warmth, hospitality-grade durability, and trade pricing built for high-end residential and hospitality developments.",
  galleryImages: [
    {
      src: "/images/bath/aria-monolith.jpg",
      alt: "ARIA Monolith oval freestanding solid surface bathtub — hero shot",
      title: "ARIA Monolith — Hero",
      caption: "Hero · Oval monolithic silhouette",
      description: "Front-facing hero of the ARIA Monolith oval freestanding solid surface bathtub in matte white.",
    },
    {
      src: "/images/bath/aria-monolith-detail.jpg",
      alt: "ARIA Monolith bathtub seamless cast solid surface rim detail close-up",
      title: "ARIA Monolith — Rim Detail",
      caption: "Detail · Seamless cast rim",
      description: "Macro detail of the ARIA Monolith's seamless cast solid surface rim and interior curvature.",
    },
    {
      src: "/images/bath/aria-monolith-side.jpg",
      alt: "ARIA Monolith bathtub side profile architectural oval form",
      title: "ARIA Monolith — Side Profile",
      caption: "Profile · Architectural side",
      description: "Side profile of the ARIA Monolith showing the architectural oval form and floor-mount footprint.",
    },
    {
      src: "/images/bath/aria-monolith-suite.jpg",
      alt: "ARIA Monolith bathtub installed in luxury hotel suite bathroom",
      title: "ARIA Monolith — Suite Lifestyle",
      caption: "Lifestyle · Suite installation",
      description: "Lifestyle scene: ARIA Monolith specified in a five-star hotel guest suite with stone walls.",
    },
    {
      src: "/images/bath/aria-monolith-villa.jpg",
      alt: "ARIA Monolith oval bathtub in private villa primary bathroom",
      title: "ARIA Monolith — Villa Lifestyle",
      caption: "Lifestyle · Private villa",
      description: "Lifestyle scene: ARIA Monolith as the focal point of a private villa primary bathroom.",
    },
  ],
  specs: [
    { label: "Dimensions", value: "1750 × 850 × 560 mm (L × W × H)" },
    { label: "Material", value: "Cast Solid Surface (Stone Resin Composite)" },
    { label: "Finish", value: "Matte White (Gloss available on request)" },
    { label: "Installation", value: "Freestanding · Floor-mounted" },
    { label: "Weight", value: "≈ 100 kg (empty)" },
    { label: "Capacity", value: "≈ 260 L to overflow" },
    { label: "Drainage", value: "Concealed centre pop-up · Chrome / Brushed Gold" },
    { label: "Certification", value: "CE Marked · EN 14516 compliant" },
    { label: "Warranty", value: "5 years structural · 2 years hardware" },
    { label: "MOQ (Container)", value: "Bulk pricing from 20+ units" },
  ],
  longDescription: [
    "ARIA Monolith is a pure oval freestanding bathtub cast as a single seamless solid surface form. Where ARIA Sculpt expresses rhythm through fluting, Monolith expresses calm through silhouette — a quiet, architectural object designed to anchor a primary suite or villa bathroom.",
    "Crafted in stone-resin composite, the surface is non-porous, warm to the touch, and refinishable in place. The interior curvature is engineered for ergonomic full-body immersion, while the exterior reads as a single uninterrupted plane from any approach angle.",
    "Specified by developers and interior designers building branded residences, boutique hotels and high-end villas across Europe. Trade pricing, MOQ-ready supply, and OEM finishing options available for project-scale orders.",
  ],
};

const AriaMonolith = () => <BathProductPage config={config} />;
export default AriaMonolith;
